import React from 'react';
import { Circle, G, Line, Path, Polygon, Rect, Text as SvgText } from 'react-native-svg';
import { DiagramCanvas } from '../DiagramCanvas';
import { FormulaTag } from '../FormulaTag';
import { LeaderLine } from '../LeaderLine';
import { DT } from '../tokens';

/** Flow hood K factor — capture hood over diffuser with grille bars, manifold meter, K correction. */
export function DiagramFlowHoodKFactor() {
  return (
    <DiagramCanvas>
      {/* Ceiling */}
      <Rect x={20} y={42} width={310} height={6} fill={DT.fill} stroke={DT.stroke} strokeWidth="1" />
      {/* Hatching above ceiling */}
      {Array.from({ length: 14 }).map((_, i) => (
        <Line key={i} x1={20 + i * 22} y1={30} x2={26 + i * 22} y2={42}
          stroke={DT.dim} strokeWidth="0.8" opacity={0.6} />
      ))}

      {/* Diffuser flush with ceiling */}
      <Rect x={120} y={42} width={110} height={8} fill={DT.varColor} opacity={0.85} stroke={DT.stroke} strokeWidth="1" />
      {[0, 1, 2, 3, 4, 5, 6, 7].map(i => (
        <Line key={i} x1={124 + i * 14} y1={42} x2={124 + i * 14} y2={50} stroke={DT.bg} strokeWidth="0.8" />
      ))}

      {/* Capture hood (pyramid trapezoid below diffuser) */}
      <Path d="M70,160 L100,55 L250,55 L280,160 Z" fill={DT.fill} stroke={DT.stroke} strokeWidth="1.5" opacity={0.85} />
      {/* Hood seal at ceiling */}
      <Rect x={100} y={50} width={150} height={5} fill={DT.varColor} opacity={0.4} />

      {/* Flow arrows from diffuser into hood */}
      {[140, 165, 190, 215].map((sx, i) => (
        <G key={i}>
          <Line x1={sx} y1={60} x2={sx} y2={140} stroke={DT.arrow} strokeWidth="1.4" opacity={0.85} />
          <Polygon points={`${sx},142 ${sx - 4},134 ${sx + 4},134`} fill={DT.arrow} opacity={0.85} />
        </G>
      ))}

      {/* Flow grid (manifold) inside hood */}
      <Rect x={95} y={140} width={160} height={6} fill={DT.fill} stroke={DT.stroke} strokeWidth="1" />
      {Array.from({ length: 7 }).map((_, i) => (
        <Line key={i} x1={105 + i * 23} y1={140} x2={105 + i * 23} y2={146}
          stroke={DT.varColor} strokeWidth="0.8" />
      ))}

      {/* Meter / display */}
      <Rect x={130} y={170} width={90} height={28} fill={DT.fill} stroke={DT.varColor} strokeWidth="1.2" rx="3" />
      <SvgText x={175} y={183} fill={DT.desc} fontSize="7" fontFamily={DT.mono} textAnchor="middle">METER</SvgText>
      <SvgText x={175} y={194} fill={DT.varColor} fontSize="11"
        fontFamily={DT.mono} textAnchor="middle" fontWeight="700">CFM</SvgText>
      {/* Cable to display */}
      <Line x1={175} y1={170} x2={175} y2={146} stroke={DT.leader} strokeWidth="1" />

      {/* Pressure tap (signal) */}
      <Line x1={250} y1={143} x2={300} y2={170} stroke={DT.leader} strokeWidth="0.8" strokeDasharray="2,2" />

      {/* Labels */}
      <LeaderLine x1={175} y1={46} x2={70} y2={28} varName="Diffuser" desc="ceiling grille" anchor="start" />
      <LeaderLine x1={75} y1={130} x2={20} y2={130} varName="Hood" desc="capture skirt" anchor="end" />
      <LeaderLine x1={175} y1={143} x2={290} y2={130} varName="Reading" desc="meter shows raw CFM" anchor="end" />
      <LeaderLine x1={220} y1={195} x2={310} y2={210} varName="K" desc="hood correction" anchor="end" />

      <FormulaTag formula="CFM_actual = K · Reading   (K from hood calibration)" />
    </DiagramCanvas>
  );
}
